// Base
import { useEffect } from 'react'

// Redux
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { hideMessage } from '@redux/slices/utilitiesSlice'

// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'

// Components
import Text from '@components/helpers/text/Text'
import Flex from '@components/helpers/flex/Flex'
import Box from '@components/helpers/box/Box'
import SvgBox from '@components/helpers/SvgBox'

// Styles
import styles from './Message.module.sass'

// Icons
import { CheckmarkCircleOutline } from 'icons/Icons'
import { IoIosCloseCircle } from 'react-icons/io'

const Message = () => {
  const dispatch = useAppDispatch()
  const {
    message: { type, text, show }
  } = useAppSelector((state) => state.utilities)

  const isDesktop = useMediaQuery(1168)

  useEffect(() => {
    if (show) {
      const messageTimer = setTimeout(() => {
        dispatch(hideMessage())
      }, 5000)
      return () => clearTimeout(messageTimer)
    }
  }, [show, dispatch])

  const icon = (type: 'success' | 'danger') => {
    switch (type) {
      case 'success':
        return (
          <SvgBox width={isDesktop ? 16 : 12}>
            <div className={styles.message__icon}>
              <CheckmarkCircleOutline
                size={isDesktop ? 16 : 12}
                color="#45BF59"
              />
            </div>
          </SvgBox>
        )
      case 'danger':
        return (
          <SvgBox width={isDesktop ? 16 : 12}>
            <div className={styles.message__icon}>
              <IoIosCloseCircle size={isDesktop ? 16 : 12} color="#FFF" />
            </div>
          </SvgBox>
        )
      default:
        break
    }
  }

  return (
    <Box
      backgroundColor={type == 'success' ? 'green' : 'red'}
      padding={{ sm: [8], lg: [12] }}
      borderRadius={{ sm: [8] }}
      className={`${styles.message} ${show ? styles['active'] : ''}`}
      onClick={() => dispatch(hideMessage())}
    >
      <Flex
        alignItems="flex-start"
        justifyContent="center"
        columnGap={{ sm: 8, lg: 16 }}
      >
        <>
          {icon(type)}
          <Text tagName="p" variant="body-6" fontWeight={700} color="white">
            {text}
          </Text>
        </>
      </Flex>
    </Box>
  )
}

export default Message
